import { render, staticRenderFns } from "./CheckboxGroupPost.vue?vue&type=template&id=480763a1&"
import script from "./CheckboxGroupPost.vue?vue&type=script&lang=ts&"
export * from "./CheckboxGroupPost.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports